(function () {
    const $languageSelector = document.querySelector('.navigation__language');
    if ($languageSelector === null) {
        return;
    }

    let $languageSelectorItems = $languageSelector.querySelectorAll('[data-language]');
    if ($languageSelectorItems.length === 0) {
        return;
    }

    $languageSelectorItems.forEach(function (item) {
        const dataAttribute = document.querySelector('[data-sf-role="' + item.attributes['data-language'].value + '"]');
        if (dataAttribute !== null) {
            item.href = dataAttribute.value;
        }
    });
})();
